import { useState } from 'react'
import { Lightbox } from './Lightbox'

/**
 * 精舍剪影格子（前端純顯示版）
 * Admin 版有編輯 UI，前端只需要圖片顯示 + 點擊放大。
 * 同步規則：sync-transmission.sh 會跳過此檔整份覆蓋（admin 版有編輯 UI 依賴，不能直接複製），
 * 但唯讀邏輯（!isEditing 分支）要手動跟 admin 版保持一致。
 */
export function SilhouetteCell({ block, emptyColor, noAspect = false, containFit = false, onOpenLightbox }) {
  const url = block?.data?.url ?? ''
  const fullUrl = block?.data?.fullUrl ?? ''
  const [lightboxSrc, setLightboxSrc] = useState(null)

  if (!url) {
    return (
      <div style={{ width: '100%', height: noAspect ? 'auto' : '100%', backgroundColor: emptyColor ?? '#f0f0f0' }} />
    )
  }

  const openLightbox = () => onOpenLightbox ? onOpenLightbox(fullUrl || url) : setLightboxSrc(fullUrl || url)

  return (
    <>
      {noAspect
        ? <img src={url} alt="" style={{ width: '100%', height: 'auto', display: 'block', cursor: 'zoom-in' }} onClick={openLightbox} />
        : containFit
          ? <img src={url} alt="" style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: '100%', objectFit: 'contain', display: 'block', margin: '0 auto', cursor: 'zoom-in' }} onClick={openLightbox} />
          : <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', cursor: 'zoom-in' }} onClick={openLightbox} />}
      {!onOpenLightbox && lightboxSrc && <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />}
    </>
  )
}
